import React from "react";

const CustomizableNumericInput = ({ allowFraction, allowNegative, label, lowerLimit, placeholder, preprocessValue, upperLimit, value, valueSetter }: { label: string, value: string | number, valueSetter: React.Dispatch<React.SetStateAction<string | number>>, lowerLimit: number, upperLimit: number, allowNegative: boolean, allowFraction: boolean, preprocessValue: (val: string) => string | number, placeholder?: string }) => {
    return (
        <div className="excel-input-container">
            <label>{label}</label>
            <input className="inputs-container" type="text" value={value} placeholder={placeholder} onChange={(e) => {
                const inputValue = e.target.value;
                if (/^(?:-?\d*)|(?:1\/\d*)$/.test(inputValue) && (inputValue === '' || (parseInt(inputValue) >= lowerLimit && parseInt(inputValue) <= upperLimit) || (allowNegative && (inputValue === '-' || parseInt(inputValue) < 0)) || (allowFraction && inputValue.startsWith('1/') && parseInt(inputValue.split('/')[1]) < upperLimit))) {
                    valueSetter(preprocessValue(inputValue));
                }
            }}/>
        </div>
    );
}

export default CustomizableNumericInput;